import {
	githubIntegrationBaseUrl,
	pagesUrl,
	xmAppsUrl,
	adoIntegrationBaseUrl,
	adoIntegrationClientId,
	adoIntegrationRedirectUrl,
	adoIntegrationScope,
} from '../../app/config/envConfig';

export const pageSize = 10;
export const HOSTEDSITE = 'hostedSite';
export const SIZE_QUERY_PARAMETER = 'size';

export const createSiteLink = (
	platformTenantName?: string,
	organizationId?: string,
) => {
	const params = new URLSearchParams();
	if (platformTenantName) params.set('tenantName', platformTenantName);
	if (organizationId) params.set('organization', organizationId);

	const queryString = params.toString();
	return queryString
		? `${xmAppsUrl}/channels?${queryString}`
		: `${xmAppsUrl}/channels`;
};

export const vercelGithub = 'https://github.com/apps/vercel';

export const sitePagesUrl = (platformTenantName: string, siteName: string) =>
	`${pagesUrl}/editor?tenantName=${platformTenantName}&sc_site=${siteName}`;

export const minWidthMd = 768;
export const minWidthSm = 480;

export const githubIntegrationUrl = (state: string) =>
	`${githubIntegrationBaseUrl}/?state=${state}&redirect_uri=${window.location.origin}/github-callback`;

export const adoIntegrationUrl = (state: string) =>
	`${adoIntegrationBaseUrl}/?client_id=${adoIntegrationClientId}&response_type=Assertion&state=${state}&redirect_uri=${adoIntegrationRedirectUrl}&scope=${adoIntegrationScope}`;

export const foundationTemplateLearnMoreUrl =
	'https://doc.sitecore.com/xmc/en/developers/xm-cloud/index-en.html?contextId=create-project-starter-foundation';

export const ownCodeLearnMoreUrl =
	'https://doc.sitecore.com/xmc/en/developers/xm-cloud/index-en.html?contextId=create-project-existing-code';

export const NEW_SOURCE_CONTROL_ACCOUNT = 'newSourceControlAccount';

export const ADO_BRANCH_PREFIX = 'refs/heads/';

export const ENVIRONMENT_NAME_VALIDATION_PATTERN =
	'^[a-zA-Z0-9][a-zA-Z0-9_!.\\- ]*$';

export const EH_ENV_NAME_VALIDATION_PATTERN = '^[a-zA-Z0-9-]+$';
export enum EnvironmentClass {
	dev = 'dev',
	qa = 'qa',
	staging = 'staging',
	preprod = 'preprod',
	prod = 'prod',
}

export const siteDeveloperSettingsLink = ({
	platformTenantName = '',
	organizationId = '',
	siteName = '',
}: {
	platformTenantName?: string;
	organizationId?: string;
	siteName: string;
}) =>
	`${xmAppsUrl}/sites/${siteName}/developersettings?tab=sites&organization=${organizationId}&tenantName=${platformTenantName}&view=tiles`;

export const learnMoreUrl = 'http://www.sitecore.com/products/xm-cloud';

export const sitecoreStatusUrl = 'https://status.cloud.sitecore.net/status';

export const FORBID_CHARS = [`"`, `+`, `<`, `>`, `&`];

export const learnMoreUrlForContextId =
	'https://doc.sitecore.com/xmc/en/developers/xm-cloud/index-en.html?contextId=regenerate-context-ids';

export const rocketLaunchUrl =
	'https://delivery-sitecore.sitecorecontenthub.cloud/api/public/content/spot-rocket-launch';
